// extracted by mini-css-extract-plugin
export default {"spin-loader":"spin-loader__spin-loader--BwCJx","spinLoader":"spin-loader__spin-loader--BwCJx","spin":"spin-loader__spin--nUeqY"};